import {
  HydratedAsset,
  HydratedCanvasAsset,
  HydratedInterfaceAsset,
  HydratedTableAsset,
  HydratedVirtualTableAsset,
  HydratedChatbotAsset,
  HydratedAgentAsset,
  HydratedZapAsset,
  HydratedNextGenZapAsset,
} from "../folder/useFolderAssets";
import { AssetTypes } from "@zapier/utils";

export function isTableAsset(
  asset: HydratedAsset,
): asset is HydratedTableAsset | HydratedVirtualTableAsset {
  return asset.type === AssetTypes.Table && "kind" in asset && !!asset.kind;
}

export function isInterfaceAsset(
  asset: HydratedAsset,
): asset is HydratedInterfaceAsset {
  return asset.type === AssetTypes.Interface;
}

export function isCanvasAsset(
  asset: HydratedAsset,
): asset is HydratedCanvasAsset {
  return asset.type === AssetTypes.Canvas;
}

export function isChatbotAsset(
  asset: HydratedAsset,
): asset is HydratedChatbotAsset {
  return asset.type === AssetTypes.Chatbot;
}

export function isAgentAsset(
  asset: HydratedAsset,
): asset is HydratedAgentAsset {
  return asset.type === AssetTypes.Agent;
}

export function isZapAsset(asset: HydratedAsset): asset is HydratedZapAsset {
  return asset.type === AssetTypes.Zap;
}

export function isNextGenZapAsset(
  asset: HydratedAsset,
): asset is HydratedNextGenZapAsset {
  return asset.type === AssetTypes.NextGenZap;
}
